<template>
    <div
        :style="componentStyles"
        class="o-map-labels"
    >
        <MapLabel
            v-for="object in objects"
            :key="object.id"
            :selectedUnit="object.unit.name"
            target="unit"
            positionY="middle"
        >
            <slot>
                <img
                    v-if="getStepIconUrl(object)"
                    :src="getStepIconUrl(object)"
                    class="o-map-labels__icon"
                    :alt="`${$t('get-step-dialog_icon')}`"
                />
                <AMapIcon 
                    v-else
                    :direction ="icon || object.meta.portal_direction"
                />
                <!-- :direction ="object.meta.portal_direction" -->
            </slot>        
        </MapLabel>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

import AMapIcon from "../../atoms/a-map-icon/a-map-icon";
// import ADialog from "@/components/atoms/a-dialog/a-dialog";
import MapLabel from "../../../shared/components/map-viewer/labels/map-label";

import {reportWarning} from "@/utils/helpers/health-monitoring";

export default {
    name: "OMapLabels",
    inject: ['mapViewer'],
    components: {
        // ADialog,
        MapLabel,
        AMapIcon
    },
    props: {
        objects: {
            type: Array,
            default: () => []
        },
        icon: {
            type: String,
            default: ''
        }
    },
    computed: {
        ...mapGetters([
            'getMapConfigProp'
        ]),
        componentStyles() {
            return this.getMapConfigProp('components.OBuildingLabels.styles') || {};
        },
        componentParams() {
            return this.getMapConfigProp('components.OBuildingLabels.params') || {};
        }
    },
    methods: {
        getStepIconUrl(object){
            const step = this.icon || object.meta.portal_direction
            let key = this.icon || object.meta.portal_direction
            if(['up', 'down', 'in', 'out'].includes(step)){
                key = _.toLower(step.type) + '-' + key
            }
            const res = this.mapViewer.mapData.config.icons.find( i => i.resource_id === key )

            if(!res){
                const msg = `Icon resource not found for key: ${key}`;
                reportWarning(msg);
            }
            return res && res.url+'?image=1'
        },
    }
}
</script>

<style lang="scss">
@import "theme";
</style>